import { render, staticRenderFns } from "./UrgencyDropdown.vue?vue&type=template&id=47cfbae5&scoped=true&"
import script from "./UrgencyDropdown.vue?vue&type=script&lang=js&"
export * from "./UrgencyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UrgencyDropdown.vue?vue&type=style&index=0&id=47cfbae5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cfbae5",
  null
  
)

export default component.exports